<template>
  <div>
    <div class="auto-height">
      <div class="card measure-side-header" style="min-height: 120px;">
        <div class="card-body" style="padding-left:12px;">
          <h5 class="mb-0">
            {{ $t('processes.processing_activities.side_table_title') }}
          </h5>
          <span class="text-success cursor-pointer" v-if="selectedFilter.id" @click="resetSelected">
            {{ $t('administration.users.create.reset_organization_label') }}
          </span>
          <span class="text-muted" v-else>
            {{ $t('processes.processing_activities.reset_selection_placeholder') }}
          </span>
        </div>
      </div>

      <span style="">
        <b-form-input
            type="text"
            v-model="filters.keywordValue"
            class="search-bar"
            style="border-radius: 0px; border: 0px; border-bottom: 1px solid #ced4da;"
            qid="search-p-input"
            v-on:input="debounceInput"
            :placeholder="$t('processes.search_placeholder')"
        ></b-form-input>
      </span>

      <div v-for="(object, index) in tableItems"
          :key="'category-row-' + index"
          :id="'category-row-' + index"
          class="filter-tree-item item-block cursor-pointer"
          :class="{'filter-tree-selected': selectedFilter.id == object.id}"
          @click="updateSelected(object)">
        <b-popover
            :target="'category-row-' + index"
            boundary="viewport"
            triggers="hover"
            placement="topleft"
            :delay="{ show: 500, hide: 0 }"
        >
          <div v-if="object.process_group" class="mt-2">
            <span class="text-bold">
              {{ $t('processes.table.process_group') }}:
            </span>
            <br>
            <span v-if="object.process_group"
                  class="cursor-pointer text-normal ml-2"
            >
              <font-awesome-icon icon="project-diagram"/>
              {{ object.process_group.name }}
            </span>
            <br>
          </div>

          <div v-if="object.description" class="mt-2">
            <span class="text-bold">
              {{ $t('maintenance.data_objects.table.description') }}:
            </span>
            <br>
            {{ object.description | truncate(200)}}
            <br>
          </div>

          <div v-if="object.tags_translated && object.tags_translated.length">
            <span class="text-bold">
              {{ $t('processes.table.tags') }}:
            </span>
            <br>
            <span v-for="tag in object.tags_translated" qid="p-tags-list">
              <span class="badge" :title="tag.name_translated">
                <font-awesome-icon icon="tag"/>
                {{ tag.name_translated }}
              </span>
            </span>
            <br>
          </div>

          <div v-if="object.users && object.users.length">
            <span class="text-bold">
              {{ $t('processes.table.owners') }}:
            </span>
            <span v-for="user in object.users">
            <br>
              <span qid="profile-photo">
                <Avatar :object="user" size="xs"></Avatar><span> {{ user.name }}</span>
              </span>
            </span>
            <br>
          </div>
        </b-popover>

        <span class="cursor-pointer" :title="object.name">
          <font-awesome-icon icon="cube"/>
          {{ object.name }}
        </span>

        <!--<span style="float: right;" v-if="!object.activities.length">-->
          <!--<font-awesome-icon-->
            <!--icon="exclamation-triangle"-->
            <!--class="risk-6"-->
            <!--v-b-tooltip.hover-->
            <!--:title="$t('processes.processing_activities.missing_activities')"-->
          <!--/>-->
        <!--</span>-->
      </div>

      <hr class="mt-0"/>
      <div class="text-center text-muted" v-if="loading">
        {{ $t('system.loading')}}
      </div>

      <div class="text-center text-muted" v-if="!loading && !tableItems.length">
        {{ $t('system.no_data')}}.
      </div>

      <InfiniteLoading
        @infinite="loadItems"
        :identifier="scrollIdentifier"
        v-if="infiniteLoading"
        ref="infiniteLoading"
        force-use-infinite-wrapper
      >
        <template slot="no-results">
          <span></span>
        </template>
      </InfiniteLoading>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import roleCheck from '@/util/ACL/roleCheck';
import Avatar from '@/components/Avatar.vue';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'ProcessSideFilter',
  data: function() {
    return {
      infiniteLoading: false,
      loading: true,
      clearList: true,
      updateCategoryListFromCreate: true,
      mySelectedCategoryId: null,
      selectedFilter: {},
      tableItems: [],
      page: 0,
      scrollIdentifier: 1,
      filters: {
        category: {},
        process_group: [],
        owners: [],
        tags:[],
        modifiedBy: [],
        modifiedFrom: '',
        modifiedTo: '',
        legalBasis: [],
        keywordValue: ''
      },
    }
  },
  computed: {
    getFilters() {
      return this.$store.state.activeFilters
    },
  },
  props: {
    selectedCategory: {},
    updateCategoryList: false,
  },
  components: {
    Avatar,
    InfiniteLoading,
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function () {
      this.tableItems = [];
      this.filters.keywordValue = '';
      this.filters.category = '';
      this.mySelectedCategoryId = null;
      this.selectedFilter = {};
      this.selectedCategory = {};
      this.clearList = true;
      this.page = 1;
      this.$store.commit('storeProcessPageNumber', this.page);
      this.$refs.infiniteLoading.stateChanger.reset();
    },
    selectedFilter: function () {

    },
    updateCategoryList: function (newValue, oldValue) {
      if (this.updateCategoryList) {
        this.clearList = false;
        this.loadItems();
      }
    },
    // Watcher for selected category - when selected item is changed from external component
    selectedCategory: function (newValue, oldValue) {
      if (this.mySelectedCategoryId && this.mySelectedCategoryId != newValue.id) {
        if (newValue) {
          this.loadItems(undefined, newValue.id);
        } else {
          this.resetSelectedWithReload();
        }
      }
    },
    getselectedFilter: function (newValue, oldValue) {
      this.$emit('updateFilter', newValue)
    },
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getselectedFilter() {
      return this.selectedFilter
    },
    getProcessPageNumber() {
      return this.$store.state.processPageNumber
    },
  },
  methods: {
    debounceInput: _.debounce(function() {
      if (this.filters.keywordValue == '' || this.filters.keywordValue.length > 2)
      this.tableItems = []
      this.filters.category = ''
      this.clearList = true
      this.page = 1
      this.$store.commit('storeProcessPageNumber', this.page);
      this.$refs.infiniteLoading.stateChanger.reset();
    }, 600),

    loadItems($state, categoryId) {
      let self = this;

      this.loading = true;

      let defaultPerPageNumber = 10;
      let pageNumber = 1;
      let perPageNumber = defaultPerPageNumber;

      if (this.clearList) {
        this.$store.commit('storeProcessPageNumber', this.page);
        pageNumber = this.page;
      }else{
        if (this.updateCategoryList || this.updateCategoryListFromCreate) {
          this.updateCategoryListFromCreate = false;

          if (this.page > 1) {
            perPageNumber = this.page * defaultPerPageNumber
          }else{
            perPageNumber = defaultPerPageNumber;
            this.page = 1;
          }
          this.$store.commit('storeProcessPageNumber', this.page);
          pageNumber = 1;
        }else{
          this.page += 1;
          this.$store.commit('storeProcessPageNumber', this.page);
          pageNumber = this.page;
        }
      }

      piincHttp.get('processes', { params:
        {
          page: pageNumber,
          per_page: perPageNumber,
          client: this.getClient.slug ? this.getClient.slug : this.getClient,
          keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined,
        }
      }).then(function(response) {
        if (response.data.items.length) {
          if (self.updateCategoryList || self.clearList) {
            self.tableItems = response.data.items;

            if ($state) {
              $state.loaded();
            }
          }else{
            self.tableItems.push(...response.data.items);

            if ($state) {
              $state.loaded();
            }
          }
        } else {
          if ($state) {
            $state.complete();
          }
        }

        if (categoryId) {
          self.tableItems.forEach((category) => {
            if (category.id == categoryId) {
              self.mySelectedCategoryId = category.id;
              self.selectedFilter = category;
              self.selectedCategory = category;

              // Emit event that selected item is updated
              self.$emit('updateSelected', category)
            }
          });
        }else{
          if (self.selectedCategory) {
            self.tableItems.forEach((category) => {
              if (category.id == self.selectedCategory.id) {
                self.mySelectedCategoryId = category.id;
                self.selectedFilter = category;
                self.selectedCategory = category;

                // Emit event that selected item is updated
                self.$emit('updateSelected', category)
              }
            });
          }
        }

        self.page = Math.ceil(self.tableItems.length / defaultPerPageNumber)
        if (self.page == 0) {self.page = 1}
        self.loading = false;
        self.clearList = false;
        self.updateCategoryList = false;
      }, function() {});
    },

    // Function for updating selected filter - when user clicks on item
    updateSelected(item) {
      if (item && item.id) {
        // If new item is different from the last one
        if (item.id != this.selectedFilter.id) {
          // Select new item and emit event that we updated selected item
          this.mySelectedCategoryId = item.id
          this.selectedFilter = item
          this.$emit('updateSelected', item)
        } else {
          // If new item is same as previous one - deselect the item
          this.mySelectedCategoryId = null
          this.resetSelected()
        }
      }
    },

    resetSelected() {
      this.selectedFilter = {};
      this.selectedFilterName = '';
      this.$emit('updateSelected')
    },
    resetSelectedWithReload() {
      this.selectedFilter = {};
      this.selectedFilterName = '';
      this.clearList = true;
      this.$refs.infiniteLoading.stateChanger.reset();
      this.$emit('updateSelected');
    }
  },
  created () {
    if (this.getClient || this.getClient.slug) {
      this.infiniteLoading = true;
      this.clearList = false;
      this.page = this.getProcessPageNumber ? this.getProcessPageNumber : 0;
      // if (this.page > 1) {this.updateCategoryListFromCreate = true}

      // if (this.selectedCategory) {
      //   this.mySelectedCategoryId = this.selectedCategory.id
      //   this.selectedFilter = this.selectedCategory
      // }
    }
  }
}
</script>
